import "./radio-group.css";

export default function RadioGroup({ name, value, buttons, style, item_style, onChange }) {
   return (
      <div 
         className="radio-group" 
         style={ style }
         role="radiogroup"
         aria-label={name}
      >
         { buttons && buttons.map(({ value: v, label }) => {
         
            const checked = value === v;

            return (
               <div
                  key={ v }
                  className="radio-item"
                  style={ item_style }
                  role="radio"
                  aria-checked={checked}
                  tabIndex={0}
                  onClick={() => onChange && onChange(
                     name,
                     v,
                     { v, label }
                  )}
                  onKeyDown={(e) => {
                     if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onChange && onChange( name, v, { v, label });
                     }
                  }}
               >
                  <div className="radio-item-box" aria-hidden="true">
                     { checked && <span/> }
                  </div>

                  { label }
               </div>
            )
         })}
      </div>
   )
}